module.exports = __webpack_public_path__ + "img/jingyingbang-gd.f35a9e9e.png";